import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93442ef2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-brack sticky-top bg-brack flex-nowrap py-2 shadow w-100" }
const _hoisted_2 = { class: "container-fluid h-100" }
const _hoisted_3 = { class: "col-6 h-100" }
const _hoisted_4 = { class: "nav col-6 flex-nowrap justify-content-end h-100" }
const _hoisted_5 = {
  key: 0,
  class: "nav-item d-none d-md-block"
}
const _hoisted_6 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_7 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_8 = {
  key: 3,
  class: "nav-item d-none d-md-block"
}
const _hoisted_9 = {
  key: 4,
  class: "nav-item d-block d-md-none btn-toolbar"
}

import { useStore } from '@/store'
import TheHeaderLogo from './TheHeaderLogo.vue'
import TheHeaderAccount from './TheHeaderAcount.vue'
import TheHeaderLang from './TheHeaderLang.vue'
import TheHeaderLangIcon from './TheHeaderLangIcon.vue'
import TheHeaderHelp from './TheHeaderHelp.vue'
import TheHeaderLogout from './TheHeaderLogout.vue'
import TheHeaderMenuVue from './TheHeaderMenu.vue'


import { defineComponent, computed } from 'vue'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TheHeader',
  setup(__props) {

const store = useStore()
// 各コンポーネントの表示・非表示状態
// v-showはテンプレート(コンポーネント)に使用できないのでv-ifかコンポーネントに通知する必要あり
const isAccount = computed(() => store.getters.headerAccount)
const isLang = computed(() => store.getters.headerLang)
const ishelp = computed(() => store.getters.headerHelp)
const isLogout = computed(() => store.getters.headerLogout)
const isMenu = computed(() => store.getters.headerMenu)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeaderLang, { "data-test": "headerLangIcon" }),
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(TheHeaderLogo, { "data-test": "headerLogo" })
        ]),
        _createElementVNode("ul", _hoisted_4, [
          (_unref(isAccount))
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createVNode(TheHeaderAccount, { "data-test": "headerAccount" })
              ]))
            : _createCommentVNode("", true),
          (_unref(isLang))
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createVNode(TheHeaderLangIcon, { "data-test": "headerLangIcon" })
              ]))
            : _createCommentVNode("", true),
          (_unref(ishelp))
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createVNode(TheHeaderHelp, { "data-test": "headerHelp" })
              ]))
            : _createCommentVNode("", true),
          (_unref(isLogout))
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _createVNode(TheHeaderLogout, { "data-test": "headerLogout" })
              ]))
            : _createCommentVNode("", true),
          (_unref(isMenu))
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createVNode(TheHeaderMenuVue, { "data-test": "headerMenu" })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})